import React from "react";
import { useOverrides, Formspree } from "@quarkly/components";
import { Text, Box, Input, Button, Section } from "@quarkly/widgets";
const defaultProps = {
	"background": "--color-lightD1",
	"color": "--dark",
	"padding": "64px 0 64px 0"
};
const overrides = {
	"box": {
		"kind": "Box",
		"props": {
			"margin": "-16px -16px -16px -16px",
			"display": "flex",
			"flex-wrap": "wrap"
		}
	},
	"box1": {
		"kind": "Box",
		"props": {
			"padding": "16px 16px 16px 16px",
			"width": "50%",
			"lg-width": "100%"
		}
	},
	"box2": {
		"kind": "Box",
		"props": {}
	},
	"text": {
		"kind": "Text",
		"props": {
			"font": "--base",
			"color": "--grey",
			"letter-spacing": "1px",
			"text-transform": "uppercase",
			"margin": "0",
			"children": "Contact FORM"
		}
	},
	"text1": {
		"kind": "Text",
		"props": {
			"font": "--headline3",
			"max-width": "500px",
			"margin": "10px 0 0 0",
			"children": "Leave us your contact info and we will reach you back!"
		}
	},
	"box3": {
		"kind": "Box",
		"props": {
			"width": "50%",
			"padding": "8px 8px 8px 8px",
			"lg-width": "100%"
		}
	},
	"box4": {
		"kind": "Box",
		"props": {}
	},
	"formspree": {
		"kind": "Formspree",
		"props": {
			"endpoint": "xeqpgrlv",
			"completeText": "Thank you for contacting us! We will respond within 48 hours."
		}
	},
	"box5": {
		"kind": "Box",
		"props": {
			"gap": "16px",
			"display": "grid",
			"flex-direction": "row",
			"flex-wrap": "wrap",
			"grid-template-columns": "repeat(2, 1fr)",
			"grid-gap": "16px"
		}
	},
	"box6": {
		"kind": "Box",
		"props": {
			"sm-width": "100%",
			"display": "flex",
			"flex-direction": "column"
		}
	},
	"text2": {
		"kind": "Text",
		"props": {
			"font": "--base",
			"margin": "0 0 4px 0",
			"children": "Name"
		}
	},
	"input": {
		"kind": "Input",
		"props": {
			"width": "100%",
			"name": "name",
			"type": "text"
		}
	},
	"box7": {
		"kind": "Box",
		"props": {
			"sm-width": "100%",
			"display": "flex",
			"flex-direction": "column"
		}
	},
	"text3": {
		"kind": "Text",
		"props": {
			"font": "--base",
			"margin": "0 0 4px 0",
			"children": "Phone"
		}
	},
	"input1": {
		"kind": "Input",
		"props": {
			"width": "100%",
			"type": "phone",
			"name": "phone"
		}
	},
	"box8": {
		"kind": "Box",
		"props": {
			"display": "flex",
			"flex-direction": "column",
			"grid-column": "1 / span 2"
		}
	},
	"text4": {
		"kind": "Text",
		"props": {
			"font": "--base",
			"margin": "0 0 4px 0",
			"children": "E-mail"
		}
	},
	"input2": {
		"kind": "Input",
		"props": {
			"type": "email",
			"name": "email"
		}
	},
	"box9": {
		"kind": "Box",
		"props": {
			"display": "flex",
			"flex-direction": "column",
			"align-items": "flex-start",
			"grid-column": "1 / span 2"
		}
	},
	"button": {
		"kind": "Button",
		"props": {
			"background": "--color-darkL2"
		}
	}
};

const Form3 = props => {
	const {
		override,
		children,
		rest
	} = useOverrides(props, overrides, defaultProps);
	return <Section {...rest}>
		<Box {...override("box")}>
			<Box {...override("box1")}>
				<Box {...override("box2")}>
					<Text {...override("text")} />
					<Text {...override("text1")} />
				</Box>
			</Box>
			<Box {...override("box3")}>
				<Box {...override("box4")}>
					<Formspree {...override("formspree")}>
						<Box {...override("box5")}>
							<Box {...override("box6")}>
								<Text {...override("text2")} />
								<Input {...override("input")} />
							</Box>
							<Box {...override("box7")}>
								<Text {...override("text3")} />
								<Input {...override("input1")} />
							</Box>
							<Box {...override("box8")}>
								<Text {...override("text4")} />
								<Input {...override("input2")} />
							</Box>
							<Box {...override("box9")}>
								<Button {...override("button")}>
									Send
								</Button>
							</Box>
						</Box>
					</Formspree>
				</Box>
			</Box>
		</Box>
		{children}
	</Section>;
};

Object.assign(Form3, { ...Section,
	defaultProps,
	overrides
});
export default Form3;